import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import ModeNightRoundedIcon from '@mui/icons-material/ModeNightRounded';

import { setTheme } from '../store/modeSlice';

function ToggleColorMode() {
  const colorMode =  useSelector((state) => state.theme.mode);
  const [mode,setMode] = React.useState(colorMode);
  const dispatch = useDispatch();
  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  React.useEffect(() => {
    dispatch(setTheme(mode));
  }, [mode]);

  return (
    <Box sx={{ maxWidth: '32px' }}>
      <Button
        variant="text"
        onClick={toggleColorMode}
        size="small"
        aria-label="button to toggle theme"
        sx={{ minWidth: '32px', height: '32px', p: '4px' }}
      >
        {mode === 'dark' ? (
          <WbSunnyRoundedIcon fontSize="small" style={{ color:"#B355F6"}} />
        ) : (
          <ModeNightRoundedIcon fontSize="small"  style={{ color:"#750AC2"}}/>
        )}
      </Button>
    </Box>
  );
}

export default ToggleColorMode;